import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { ActivityFilter, IActivityLogs, IEditETicket, IETicket, IETickets, IETicketsForDropdown } from './e-ticket.model';

@Injectable()
export class ETicketService {
    constructor(
        private http: HttpClient
    ) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'events/{eventId}/etickets';

    /** GET */
    public getETicket(eventId: string, eTicketId: string): Observable<SuccessResponse<IETicket> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IETicket>>(
                ETicketService.URL +
                ETicketService.ENDPOINT.replace('{eventId}', eventId) +
                '/' + eTicketId,
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getETickets(eventId: string): Observable<SuccessResponse<IETickets> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IETickets>>(
                ETicketService.URL +
                ETicketService.ENDPOINT.replace('{eventId}', eventId),
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getETicketsForDropdown(eventId: string): Observable<SuccessResponse<IETicketsForDropdown> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IETicketsForDropdown>>(
                ETicketService.URL +
                ETicketService.ENDPOINT.replace('{eventId}', eventId) + '/dropdowns',
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    /** PUT */
    public updateETicket(eventId: string, eTicketId: string, eTicket: IEditETicket): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(
                ETicketService.URL +
                ETicketService.ENDPOINT.replace('{eventId}', eventId) +
                '/' + eTicketId,
                eTicket
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    /** POST */
    public addETicket(eventId: string, eTicket: IEditETicket): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(
                ETicketService.URL +
                ETicketService.ENDPOINT.replace('{eventId}', eventId),
                eTicket
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    /** DELETE */
    public deleteETicket(eventId: string, eTicketId: string): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .delete<SuccessResponse<boolean>>(
                ETicketService.URL +
                ETicketService.ENDPOINT.replace('{eventId}', eventId) +
                '/' + eTicketId,
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getActivityLogs(eventId: string, activityFilter: ActivityFilter): Observable<SuccessResponse<IActivityLogs> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IActivityLogs>>(ETicketService.URL +
                ETicketService.ENDPOINT.replace('{eventId}', eventId) +
                '/activities', activityFilter)
            .pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
